import { STORAGE_QUOTA_EXCEEDED_MESSAGES } from '@photosi/expo-photosi-sdk';
import { ErrorType } from '../../errors-handler/ErrorsHandler.types';
import { extractErrorEventInfo } from '../ErrorViews.utils';
import { logWarning } from 'src/_shared/logger';

export const isNoAvailableSpaceError = ({ event }: ErrorType) => {
  const { message } = extractErrorEventInfo(event);
  return isNoAvailableSpaceErrorMessage(message);
};

export const isNoAvailableSpaceErrorMessage = (message?: string) => {
  return message && STORAGE_QUOTA_EXCEEDED_MESSAGES.some(m => message.includes(m));
};

export const cleanIndexDB = async () => {
  if (typeof indexedDB === 'undefined' || typeof indexedDB.databases !== 'function') {
    return;
  }

  try {
    const databases = await indexedDB.databases();
    if (Array.isArray(databases)) {
      await Promise.all(
        databases
          .filter((db): db is IDBDatabaseInfo & { name: string } => !!db.name)
          .map(
            ({ name }) =>
              new Promise<void>(resolve => {
                const request = indexedDB.deleteDatabase(name);
                request.onsuccess = () => resolve();
                request.onerror = () => resolve();
                request.onblocked = () => resolve();
              }),
          ),
      );
    }
  } catch (e) {
    logWarning('[cleanIndexDB] failed to clean IndexedDB', e);
  }
};
